import { render } from "./AdminNavigation.vue?vue&type=template&id=71913291&scoped=true"
const script = {}

import "./AdminNavigation.vue?vue&type=style&index=0&id=71913291&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chrpauls\\OneDrive - Grenland Data AS\\Dokumenter\\Projects\\170323\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71913291"]])

export default __exports__